import React, { useContext, useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import FixtureGoals from '../components/Public/Fixtures/FixtureGoals';
import { firestore } from '../firebase';
import StateContext from '../StateContext';

function SingleFixturePage() {

    const {id} = useParams();

    const appState = useContext(StateContext)

    const [fixture, setFixture] = useState();

    useEffect(() => {

        try {
            const fixtureRef = firestore.collection("fixtures").doc(id);
            fixtureRef.onSnapshot(doc => {
                const fixture = {id: doc.id, ...doc.data()}
                setFixture(fixture)
            })
        } catch (error) {
            
        }

    }, [id]);

    return (
        <div>
            <div className="container my-4">

                {appState.loggedIn && <Link to={`/edit-fixture/${id}`}><i className="fas fa-edit"></i></Link>}
                <div className="row py-2">
                    <div className="col-5">
                        <div className="float-right">
                            {fixture?.home_team} <img src={fixture?.home_team_logo} alt={fixture?.home_team} className="img-fluid rounded-circle logo-medium-square" />
                        </div>
                    </div>
                    <div className="col-2">
                        <div className="text-center py-2">
                            {fixture?.home_goals}-{fixture?.away_goals}
                        </div>
                    </div>
                    <div className="col-5">
                        <img src={fixture?.away_team_logo} alt={fixture?.away_team} className="img-fluid rounded-circle logo-medium-square" /> {fixture?.away_team}
                    </div>
                </div>

                {fixture && <FixtureGoals fixture={fixture} fixtureId={fixture.id} />}
            </div>

        </div>
    )
}
export default SingleFixturePage